import { render, staticRenderFns } from "./CheckoutComponent.vue?vue&type=template&id=b296cee6&scoped=true"
import script from "./CheckoutComponent.vue?vue&type=script&lang=js"
export * from "./CheckoutComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckoutComponent.vue?vue&type=style&index=0&id=b296cee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b296cee6",
  null
  
)

export default component.exports